import Collapse from '@mui/material/Collapse'
import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import CountBadge from '../components/CountBadge/CountBadge'
import { Button } from '@mui/material'

const SubMenu = ({ isChild, icon, name, path, index, onNavigate }) => {
  const location = useLocation()
  const [open, setOpen] = useState(true)
  
  // Get count tracking from context
  const menuCounts = {
    'Cancelled Consultation': 0,
    'Waitlist Management': 0,
    'Missed Chat/Call': 0,
    'Progress Chat/Call': 0,
    'Completed Chat/Call': 0,
    'Support Management': 0,
    'Booked Session-Waitlist': 0
  }
  const markAsRead = async (entryIds = null, type = null) => {
    console.log('markAsRead', entryIds, type);
  }

  const trackMenuClick = async (menuItem) => {
    console.log('trackMenuClick', menuItem);
  }

  // Handle menu click tracking
  const handleMenuClick = async (menuName) => {
    try {
      await trackMenuClick(menuName);
    } catch (error) {
      console.error('Error tracking menu click:', error);
    }
  };

 
 
  return (
    <li
      className={location.pathname === path ? 'active' : ''}
      // className={isChild.some(child => location.pathname === child.path) ? "active" : ""}
    >
      <a onClick={() => setOpen(!open)}>
        <span>{icon}</span>
        {name}
        <CountBadge 
          count={menuCounts[name] || 0}
          variant="auto"
          size="sm"
        />
        {open ? <KeyboardArrowDownIcon /> : <ChevronRightIcon />}
      </a>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <ol className={`dropdown-menu ${open && 'd-block'}`}>
          {isChild &&
            isChild
              .filter((child) => child.enabled)
              .map((child) => {
                return (
                  <li
                    className={`py-2 ${
                      location.pathname === child.path ? 'active' : ''
                    }`}
                    key={child.path}
                  >
                    <NavLink 
                      to={child.path}
                      onClick={() => {
                        if (onNavigate) onNavigate();
                        handleMenuClick(child.name);
                        markAsRead(null, child.name);
                       
                      }}
                    >
                      <span className="">{child.icon}</span>
                      {child.name}
                      <CountBadge 
                        count={menuCounts[child.name] || 0}
                        variant="auto"
                        size="sm"
                      />
                    </NavLink>
                  </li>
                )
              })}
        </ol>
      </Collapse>
    </li>
  )
}

export default SubMenu
